module.exports = __webpack_public_path__ + "img/right.e2d8e86d.svg";